import { render, staticRenderFns } from "./vendorBrand.vue?vue&type=template&id=5e694c28&scoped=true"
import script from "./vendorBrand.vue?vue&type=script&lang=js"
export * from "./vendorBrand.vue?vue&type=script&lang=js"
import style0 from "./vendorBrand.vue?vue&type=style&index=0&id=5e694c28&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e694c28",
  null
  
)

export default component.exports